<template>
  <el-card class="page-container">
    <h1 class="title-biaoti">主播保收记录报表</h1>
    <el-row :gutter="20" class="user-options">
      <el-col :span="7">
        <span>收入时间</span>
        <el-date-picker
          v-model="platformData"
          type="daterange"
          align="right"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="retainedOptions"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
      </el-col>
      <el-col :span="7">
        <span>转正时间</span>
        <el-date-picker
          v-model="platformData1"
          type="daterange"
          align="right"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="retainedOptions"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
      </el-col>
      <el-col :span="4">
        <span>国家</span>
        <el-select
          filterable
          style="width: 160px"
          v-model="country"
          placeholder=""
        >
          <el-option
            v-for="(item, itemIndex) in countryList"
            v-bind:key="itemIndex + 99"
            :label="item.country"
            :value="item.countryCode"
          ></el-option>
        </el-select>
      </el-col>
      <el-col :span="3">
        <el-input v-model="agentId" placeholder="代理id 选填"></el-input>
      </el-col>
      <el-col :span="3">
        <el-input v-model="rid" placeholder="主播id 选填"></el-input>
      </el-col>

      <el-col :span="6">
        <el-button type="warning" @click="getDayChatDetai" :loading="login1">
          查询
        </el-button>
        <el-button type="success" @click="dwnDayChatDetai" :loading="login2">
          下载
        </el-button>
      </el-col>
    </el-row>
    <el-row class="user-options">
      <el-table
        :data="dayChatDetailData"
        style="width:100%;"
        v-loading="login1"
        height="80vh"
        stripe
        border
      >
        <el-table-column prop="index" fixed label="No" width="80">
        </el-table-column>
        <el-table-column prop="rid" fixed label="主播ID" width="110">
        </el-table-column>
        <el-table-column prop="head" fixed label="主播头像" width="180">
          <template slot-scope="scope">
            <el-image
              style="width: 180px; height: 180px"
              :src="scope.row.head"
              fit="contain"
              :preview-src-list="[scope.row.head]"
            ></el-image>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="主播昵称" width="180">
        </el-table-column>
        <el-table-column prop="isNewHost" label="新老主播" width="180">
          <template slot-scope="scope">
            {{ scope.row.isNewHost == 0 ? '不是' : '是' }}
          </template>
        </el-table-column>
        <el-table-column prop="country" label="主播国家" width="180">
        </el-table-column>
        <el-table-column prop="language" label="语言" width="180">
        </el-table-column>
        <el-table-column prop="onlineTime" label="在线时长" width="180">
        </el-table-column>
        <el-table-column prop="appraiseScore" label="等级评分" width="180">
        </el-table-column>
        <el-table-column prop="agentName" label="代理名" width="180">
        </el-table-column>
        <el-table-column prop="agentId" label="代理id" width="180">
        </el-table-column>
        <el-table-column prop="guaranteedCalls" label="保收通话数" width="180">
        </el-table-column>
        <el-table-column
          prop="callConnectTimes"
          label="保收通话接通数"
          width="180"
        >
        </el-table-column>
        <el-table-column
          prop="guaranteeMatchTimes"
          label="保收匹配卡次数"
          width="180"
        >
        </el-table-column>
        <el-table-column prop="matchIncome" label="匹配卡任务收入" width="180">
        </el-table-column>

        <el-table-column
          prop="guaranteedCoins"
          label="通话保收收入"
          width="180"
        >
        </el-table-column>
        <el-table-column
          prop="totalGuaranteeIncome"
          label="总保收收入"
          width="180"
        >
        </el-table-column>
        <el-table-column
          prop="guaranteedIncomeDollar"
          label="保收收入-美元"
          width="180"
        >
        </el-table-column>
        <el-table-column prop="callTimes" label="通话次数" width="180">
        </el-table-column>
        <el-table-column prop="callIncome" label="通话收入" width="180">
        </el-table-column>
        <el-table-column prop="giftIncome" label="礼物收入" width="180">
        </el-table-column>
        <el-table-column
          prop="matchTaskReward"
          label="任务奖励收入"
          width="180"
        >
        </el-table-column>
        <el-table-column prop="mtime" label="转正时间" width="180">
        </el-table-column>
        <el-table-column prop="totalIncome" label="总收入" width="180">
        </el-table-column>
        <el-table-column
          prop="totalIncomeDollar"
          label="总收入-美元"
          width="180"
        >
        </el-table-column>
        <el-table-column
          prop="guaranteedIncomeRate"
          label="保收收入占比"
          width="180"
        >
        </el-table-column>
        <el-table-column
          prop="inviteUserIncome"
          label="引入用户分成收入"
          width="180"
        >
        </el-table-column>
      </el-table>
    </el-row>
    <el-row class="user-options">
      <el-pagination
        :current-page.sync="page"
        layout="total, prev, pager, next"
        background
        @current-change="handleCurrentChange"
        :total="total"
        class="pagination"
        :page-size="10"
      ></el-pagination>
    </el-row>
  </el-card>
</template>

<script>
import download from '@/utils/download.js'
import { datainfor } from '@/utils/formdata.js'
import { getCountry, getLanguage } from '@/utils/normalApi.js'
import { mapState } from 'vuex'

export default {
  data () {
    return {
      // 加载
      login1: false,
      login2: false,
      // 用户id白名单 MultipartFile文件
      ridFile: '',
      // 代理名或者代理id
      agentName: '',
      // 通话日期
      platformData: [datainfor(7), datainfor(1)],
      platformData1: null,
      retainedOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now()
        }
      },
      // 分引
      page: 1,
      total: 0,
      // 表格数据
      dayChatDetailData: [],

      country: 'total',
      countryList: [],
      agentId: '',
      rid: '',
      language: 'all',
      languageList: [],
      assRating: '',
      score: '',
      labelId: 0
    }
  },
  computed: {
    ...mapState(['faceValueList'])
  },
  async created () {
    await this._getLanguage()
    this.getDayChatDetai()
    this._getCountry()
  },
  methods: {
    async _getCountry () {
      const res = await getCountry()
      if (res !== null) {
        this.countryList = res.countryList
      }
    },
    async _getLanguage () {
      const res = await getLanguage()
      if (res !== null) {
        this.languageList = res
        this.language = res[0].langCode
      }
    },
    // 查询列表
    async getDayChatDetai () {
      this.login1 = true
      if (this.platformData == null) {
        this.platformData = ['', '']
      }
      if (this.platformData1 == null) {
        this.platformData1 = ['', '']
      }
      const { data: res } = await this.$axios({
        method: 'post',
        url: this.$store.getters.path.guarantee_pool,
        withCredentials: true,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token
        },
        data: {
          start: this.platformData[0],
          end: this.platformData[1],
          time: this.platformData1[0],
          finish: this.platformData1[1],
          page: this.page,
          countryCode: this.country,
          agentId: this.agentId,
          rid: this.rid
        }
      })
      this.login1 = false
      if (res.code != 0) return this.$message(res.msg)
      let newList = []
      res.data.data.map((e, i) => {
        newList.push({ index: i + 1 + (this.page - 1) * 10, ...e })
      })
      this.dayChatDetailData = newList
      this.total = res.data.total
    },
    // 下载
    async dwnDayChatDetai () {
      this.login2 = true
      if (this.platformData == null) {
        this.platformData = ['', '']
      }
      if (this.platformData1 == null) {
        this.platformData1 = ['', '']
      }
      const res = await this.$axios({
        method: 'post',
        url: this.$store.getters.path.guarantee_pool_download,
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json'
        },
        responseType: 'blob',
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token
        },
        data: {
          start: this.platformData[0],
          end: this.platformData[1],
          time: this.platformData1[0],
          finish: this.platformData1[1],
          countryCode: this.country,
          agentId: this.agentId,
          rid: this.rid
        }
      })

      this.$message.success('开始下载')
      this.login2 = false
      download(res.data, '主播保收记录报表' + this.platformData[1])
    },
    // 分页
    handleCurrentChange () {
      this.getDayChatDetai()
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '../../assets/stylus/variable.styl';

.page-container {
  margin-left: 20px;
  margin-top: 20px;

  .el-col {
    display: flex;
    align-items: center;

    >div {
      margin-right: 5px;
    }
  }

  h1 {
    font-size: 28px;
    font-weight: bold;
  }

  .user-options {
    margin-top: 40px;

    button {
      margin-left: 30px;
    }

    .el-col {
        margin-bottom: 20px
    }
  }

  .display-type {
    margin-top: 20px;

    .line {
      width: 1440px;
      height: 700px;
    }
  }

}
</style>